import {MediaType, type Media} from './media';

export interface NewsCardView {
  uuid: string;
  title: string;
  image: Media;
  publishedAt: string;
  categories: NewsCategoryView[];
  tag?: string | undefined;
}

export interface NewsCategoryView {
  uuid: string;
  name: string;
  key: string;
}

export interface NewsArticleDetailView {
  uuid: string;
  title: string;
  imageUrl?: string;
  publishedAt: string; // ISO date (YYYY-MM-DD), matching NewsCardView
  categories: string[];
  mainMedia: Media;
  description?: string;
  body?: string;
  gallery: Media[];
}

export function formatPublishDate(isoDate: string, language: string): string {
  const parsed = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return isoDate;
  }
  return new Intl.DateTimeFormat(language.startsWith('ar') ? 'ar-EG' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(parsed);
}

export interface WireNewsCard {
  uuid: string;
  imageUrl?: string;
  title?: string;
  subtitle?: string;
  publishDate?: string;
  tag?: string;
  isFavorite?: boolean;
}

const ISO_DATE_PREFIX_LENGTH = 10;

export function newsCardFromWire(card: WireNewsCard): NewsCardView {
  return {
    uuid: card.uuid,
    title: card.title ?? '',
    image: {type: MediaType.Image, src: card.imageUrl ?? '', alt: card.title},
    publishedAt: (card.publishDate ?? '').slice(0, ISO_DATE_PREFIX_LENGTH),
    categories: card.tag ? [{uuid: card.tag, name: card.tag, key: card.tag}] : [],
  };
}
